import { FieldMetaProps } from "formik";

export const getError = (meta: FieldMetaProps<unknown>) => {
  if (!!meta.touched && !!meta.error) {
    return meta.error;
  }
};
